import React, { useState } from "react";
import water_menu_logo from "../../images/water_menu_logo.png";
import { Navbar, Nav, NavDropdown, Container, Image } from "react-bootstrap";
import footer_logo from "../../images/logo-footer-crop.png";
import ChangePasswordPopup from "../login/ChangePassword";
import AuthHelper from "../../helpers/AuthHelper";
import FluentdHelper from "../../helpers/FluentdHelper";
import { resetState } from "../../configurations/redux-configurations/actions/fieldAction";
import { resetUserState } from "../../configurations/redux-configurations/actions/userAction";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import StorageHelper from "../../helpers/StorageHelper";
import SessionHelper from "../../helpers/SessionHelper";
import {
  EXISTING_ACCOUNT_LOGIN,
  WDP_TPNRD_NO_COST,
} from "../../configurations/MessageConstants";
import {
  EMPTY,
  FARMER_HEADER_OPTIONS,
  LOG_OUT,
  LOGGING_OUT,
} from "../../configurations/Constants";

function FarmerHeader(props) {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user.userInfo);
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const registeredUser = useSelector((state) => state.user.registeredUser);
  const [openChangePassword, setOpenChangePassword] = useState(false);

  const handleLogOut = () => {
    if (SessionHelper.isStaffMember()) window.close();
    dispatch(resetState());
    dispatch(resetUserState());
    AuthHelper.SignOut();
    FluentdHelper.logEvent(
      `User ${loggedInUser} successfully logged out from TPNRD.`,
      "handleLogOut_logOutFromAWSAmplify",
      loggedInUser,
      {
        request: EMPTY,
        response: EMPTY,
      }
    );
    StorageHelper.setItem(LOGGING_OUT, LOG_OUT + Math.random());
    StorageHelper.removeItem(LOGGING_OUT);
    StorageHelper.clear();
  };

  const closeModal = () => {
    setOpenChangePassword(false);
  };
  const handleChangePassword = () => {
    setOpenChangePassword(true);
  };

  const current_user = loggedInUser || registeredUser;
  const logoClass = loggedInUser ? EMPTY : "disable-click-pointer";
  return (
    <header className="farmer-header">
      <Navbar expand="sm">
        <Container fluid>
          <Navbar.Brand className={loggedInUser ? EMPTY : "brand-margin"}>
            <ChangePasswordPopup
              showChangePasswordPopup={openChangePassword}
              closeModal={(e) => closeModal(e)}
            ></ChangePasswordPopup>
            <span className="header-logo-border">
              <Link to="/dashboard" className={logoClass}>
                <img
                  id="water_menu_logo"
                  src={water_menu_logo}
                  alt="Water Data Program Logo"
                />
              </Link>
            </span>
          </Navbar.Brand>
          {loggedInUser && (
            <NavDropdown id="collasible-nav-dropdown" className="logo-menu">
              {FARMER_HEADER_OPTIONS.map((option) => (
                <div key={option.value}>
                  <NavDropdown.Item href={`/${option.value}`} className="mb-2">
                    {option.name}
                  </NavDropdown.Item>
                </div>
              ))}
            </NavDropdown>
          )}
          <Navbar.Brand className="navbar-header-title">
            <img src={footer_logo} alt="footer-logo" />{" "}
            <span className="mt-5 footer-text">{WDP_TPNRD_NO_COST}</span>
          </Navbar.Brand>

          <Nav className={current_user ? "ms-auto" : "ms-auto d-none"}>
            <NavDropdown
              title={
                current_user ? (
                  <div className="d-flex align-items-center gap-2">
                    {userInfo.profile_pic ? (
                      <Image
                        src={userInfo.profile_pic}
                        roundedCircle
                        height={35}
                        width={35}
                        className="header-profile-image"
                      />
                    ) : (
                      <i className="fa fa-user-circle header-placeholder-image"></i>
                    )}
                    <span>{current_user}</span>
                  </div>
                ) : (
                  "username"
                )
              }
              id="collasible-nav-dropdown"
            >
              {loggedInUser && (
                <>
                  <NavDropdown.Item onClick={(e) => handleChangePassword()}>
                    <i className="fa fa-key" />
                    Change Password
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/profile">
                    <i className="fa fa-user" />
                    User Profile
                  </NavDropdown.Item>
                </>
              )}
              <NavDropdown.Item href="/login" onClick={(e) => handleLogOut()}>
                <i className="fa fa-sign-out" />
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Nav
            className={
              current_user
                ? "navbar-index-position ms-auto d-none"
                : "navbar-index-position ms-auto"
            }
          >
            <Link to="/login" className="no-underline">
              {EXISTING_ACCOUNT_LOGIN}
            </Link>
          </Nav>
        </Container>
      </Navbar>
    </header>
  );
}

export default FarmerHeader;
